<template>
  <div>
    <router-view></router-view>
  </div>
    
    
</div>

</template>

<script>
  export default {

  }
</script>

<style lang="scss">
	body {
		margin: 0;
		padding: 0;
	}

</style>


// WEBPACK FOOTER //
// src/App.vue